import {getNotEmptyObjectEntries} from 'swayok-react-mdb-ui-kit/helpers/getNotEmptyObjectEntries'
import type {ItemsCategoryPropertyFiltersFormValues} from '../modules/public/ads/AdsModuleTypes'
import {gzipStringToBase64} from './gzipStringToBase64'

// Кодирует набор фильтров в gzip + base64 строку.
export async function encodeItemsSearchFiltersForUrlQueryParam(
    filters: ItemsCategoryPropertyFiltersFormValues['props']
): Promise<string | null> {
    if (typeof filters !== 'object') {
        return null
    }
    const entries: [string, unknown][] = getNotEmptyObjectEntries(filters)
    if (entries.length === 0) {
        return null
    }
    const json = JSON.stringify(Object.fromEntries(entries))
    try {
        return gzipStringToBase64(json)
    } catch (e) {
        console.error(e)
        return json
    }
}
